import { render, staticRenderFns } from "./PromoListingContainer.vue?vue&type=template&id=8beb54e0"
import script from "./PromoListingContainer.vue?vue&type=script&lang=js"
export * from "./PromoListingContainer.vue?vue&type=script&lang=js"
import style0 from "./PromoListingContainer.vue?vue&type=style&index=0&id=8beb54e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports